/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { computeCatalogCreateComputeQuote } from "../../funcs/computeCatalogCreateComputeQuote.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.CreateComputeQuoteRequest$inboundSchema,
};

export const tool$computeCatalogCreateComputeQuote: ToolDefinition<
  typeof args
> = {
  name: "compute-catalog-create-compute-quote",
  description: `Create a quote`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await computeCatalogCreateComputeQuote(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
